/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments {
    /**
     * 
     * @type {Array<FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument>}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments
     */
    Documents: Array<FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument>;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments {
    if (!('Documents' in value) || value['Documents'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments {
    if (json == null) {
        return json;
    }
    return {
        
        'Documents': ((json['documents'] as Array<any>).map(FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentFromJSON)),
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documents': ((value['Documents'] as Array<any>).map(FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentToJSON)),
    };
}

